// The same rule as the backend's Order.valid_tracking_url?: http(s) with a host.
// Shopify's fulfillment API refuses anything else, and its error is a raw GraphQL
// message ("FulfillmentInput! ... missing host") the factory can't act on, so
// catch it here, in words, before the request goes out.
export function isValidTrackingUrl(raw) {
  try {
    const url = new URL(String(raw).trim());
    return (url.protocol === "http:" || url.protocol === "https:") && url.hostname !== "";
  } catch {
    return false;
  }
}

export const TRACKING_URL_ERROR = {
  en: "Tracking URL must be a full web address starting with http:// or https:// (for example https://www.ups.com/track?tracknum=1Z999)",
  cn: "跟踪网址必须是以 http:// 或 https:// 开头的完整网址（例如 https://www.ups.com/track?tracknum=1Z999）",
};
